import Rollbar from 'rollbar';

// Use RAILS_ENV instead of NODE_ENV
const env = process.env.RAILS_ENV;
const rollbar = new Rollbar({
    accessToken: '1a05e4b725f74ca289ed6719ea155f34',
    captureUncaught: true,
    captureUnhandledRejections: true,
    captureConsole: true,
    consoleMethods: ['error'],
    console: true,
    itemsPerMinute: 30,

    payload: {
        environment: env, // This now uses the Rails environment
        client: {
          javascript: {
            code_version: process.env.VERSION,
            source_map_enabled: true,
            guess_uncaught_frames: true
          }
        }
    }
});

export default rollbar;